import React, { Component } from 'react';

import { Polyline  } from 'google-maps-react';

import { GetOhlSegments } from '../../../helpers/spanHelpers';


class ohlFirstLevel extends Component {


    componentDidMount(){
        this.loadFirstLevelOhls();
    }

    shouldComponentUpdate(nextProps){
        if(this.props.ohlsList.length !== nextProps.ohlsList.length
            || this.props.zoomLevel !== nextProps.zoomLevel
            || this.props.showDividedSpans !== nextProps.showDividedSpans
            || this.props.ohlThickness !== nextProps.ohlThickness){
            return true;
        }
        else{
            return false;
        }
    }

    componentDidUpdate(){
        this.loadFirstLevelOhls();
    }


    loadFirstLevelOhls = () => {

        let resultList = [];

        this.props.ohlsList.forEach(ohl => {

            let ohlColor;
            switch (ohl.voltage) {
                case '35':
                    ohlColor = this.props.color35;
                    break;
                case '220':
                    ohlColor = this.props.color220;
                    break;
                case '400':
                    ohlColor = this.props.color400;
                    break;
                default:
                    ohlColor = this.props.color110;
                    break;
            }

            if (this.props.zoomLevel <= 1) {
                if (this.props.showDividedSpans && ohl.stubovi.some(pole => pole.sys > 1)) {
                    GetOhlSegments(this.props.ohlsList, ohl.stubovi, ohl.name).forEach((segment, index) => {
                        const ohlSegment =
                            <Polyline
                                key={ohl.name + String(index)}
                                path={segment.path}
                                clicable
                                onClick={this.props.onSegmentClick}
                                strokeOpacity={0.8}
                                strokeColor={segment.isDivided ? '#ff9900' : ohlColor}/*'#c242f4'*/
                                strokeWeight={this.props.ohlThickness}
                                ohls={segment.OHLs}
                            />
                        resultList.push(ohlSegment);
                    });
                }
                else {
                    const dalekovod =
                        <Polyline
                            key={ohl.name}
                            path={ohl.stubovi}
                            name={ohl.name}
                            clicable
                            onClick={this.props.onOhlClick}
                            strokeOpacity={0.8}
                            strokeColor={ohlColor}/*'#c242f4'*/
                            strokeWeight={this.props.ohlThickess}
                            voltage={ohl.voltage}
                            stubovi={ohl.stubovi}
                        />
                    resultList.push(dalekovod);
                }
            }
        });

        this.props.sendChildElementDataToState(this.props.stateElementName, resultList);
    }


    render() {
        return null;
    }
}

export default ohlFirstLevel;